import { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { useMutation } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";

import { simpleDate, simpleTime } from "../../../utils/displayDate";
import defaulAvatar from "../../../assets/images/cpf.png";
import {
  DELETE_MESSAGE,
  EDIT_MESSAGE,
} from "../../../graphql/mutations/message";
import UpdateDropdown from "./UpdateDropdown";
import SimpleModal from "../../../components/common/SimpleModal";
import UpdateMesageForm from "./UpdateMesageForm";
import SocketClient from "../../../services/SocketClient";
import { SOCKET_CLIENT } from "../../../constants/socket";
import { onChangeUpdateMessage, setUpdateMessage } from "../redux/chatSlice";
import { showErrorToast } from "../../../components/common/CustomErrorMessage";

const MessageItem = ({ message, refetch }) => {
  const dispatch = useDispatch();
  const chat = useSelector((state) => state.chat);
  const { updateMessage } = chat;
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const [deleteMessage] = useMutation(DELETE_MESSAGE, {
    onCompleted: (data) => {
      if (data.deleteMessage) {
        refetch();
        SocketClient.emit(SOCKET_CLIENT.SEND_MESSAGE, data.deleteMessage);
      }
    },
    onError: (err) => {
      showErrorToast(err.message);
    },
  });

  const [editMessage] = useMutation(EDIT_MESSAGE, {
    variables: { id: updateMessage.id, message: updateMessage.message },
    onCompleted: (data) => {
      if (data.editMessage) {
        refetch();
        handleCloseModal();
        SocketClient.emit(SOCKET_CLIENT.SEND_MESSAGE, data.editMessage);
      }
    },
    onError: (err) => {
      showErrorToast(err.message);
    },
  });

  const toggleEdit = (message) => {
    dispatch(
      setUpdateMessage({ id: message.id, message: message.text.message })
    );
    setShowModal(true);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    await editMessage();
  };
  const handleChange = (e) => dispatch(onChangeUpdateMessage(e.target.value));

  const handleDelete = async (id) => {
    const answer = window.confirm("ຕ້ອງການລຶບບໍຂໍ້ຄວາມບໍ?");
    if (answer) await deleteMessage({ variables: { id } });
  };

  const myMsg = message.isAdmin ? true : false;
  const avatar = message?.member?.profileImage ?? defaulAvatar;

  const renderTime = (date) => {
    const today = new Date();
    const todayDate = simpleDate(today);
    const msgDate = simpleDate(date);
    if (todayDate === msgDate) {
      return simpleTime(date);
    } else {
      return (
        <span>
          {simpleDate(date)} {simpleTime(date)}
        </span>
      );
    }
  };

  return (
    <>
      <SimpleModal
        show={showModal}
        handleClose={handleCloseModal}
        title="ແກ້ໄຂຂໍ້ຄວາມ"
      >
        <UpdateMesageForm
          handleSubmit={handleUpdate}
          handleChange={handleChange}
          value={updateMessage.message}
        />
      </SimpleModal>
      <div className={`message_item ${myMsg ? "my_msg" : "other"}`}>
        <div className="text-body">
          <div>{renderTime(message.createdAt)}</div>
          <Card bg={myMsg ? "primary" : "secondary"}>
            <div className={`px-2 pt-2 ${!myMsg && "d-flex"}`}>
              {!myMsg && (
                <div className="avatar pb-2">
                  <img src={avatar} alt="avatar" />
                </div>
              )}
              <Row className="">
                <Col md="10">
                  <p className={myMsg ? "text-white" : "m-2 text-white"}>
                    {message.text?.message}
                  </p>
                </Col>
                <Col md="2">
                  {myMsg ? (
                    <UpdateDropdown
                      message={message}
                      handleDelete={handleDelete}
                      handleClose={handleCloseModal}
                      toggleEdit={toggleEdit}
                    />
                  ) : null}
                </Col>
              </Row>

              {message.text.isImage ? (
                <img
                  src={message.text.imageUrl}
                  className="img-thumbnail"
                  alt="msg"
                  style={{ width: "80%" }}
                />
              ) : null}
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default MessageItem;
